import styled from '@emotion/styled';

export const RaceWinnerColumnWrapper = styled('div', { label: 'RaceWinnerColumnWrapper' })`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    width: 4.5em;
    min-width: 4.5em;
    text-align: center;
`;
export const RaceWinnerColumnTitle = styled('span', { label: 'RaceWinnerColumnTitle' })`
    position: relative;
    color: #d3e1db;
    font-size: 0.9em;
    border-left: 1px solid #dbe1de;
    border-right: 1px solid #dbe1dc;
    margin-right: -1px;
    line-height: 1.2em;
    white-space: nowrap;
    //height: 2.5em;
    min-width: 4.5em;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1px 0 6px;
`;
